module.exports = __webpack_public_path__ + "img/portrait-044.c5740ec2.jpg";